
import AIChat from 'components/ai-chat-v2'
import ChatComposer from './chat-composer.vue'
import {AddPrompt} from 'components/prompts-v2'
import {Chat} from 'stores/chats'
import {computed} from 'vue'
import $global from 'stores/global'
import ChatHeader from './chat-header.vue'
import ShareModalV2 from './chat-sharing-v2/share-modal.vue'

export default {
  components: {AIChat, ChatComposer, ShareModalV2, AddPrompt, ChatHeader},
  provide() {
    return {
      di_apollo: computed(() => this.apollo_data),
      di_chat_mode: computed({
        get: () => this.chat.mode,
        set: mode => this.chat.setMode(mode)
      })
    }
  },
  props: {
    chat: {
      type: Chat,
      required: true
    }
  },
  data() {
    return {
      sources: undefined,
      apollo_data: new Map(),
    }
  },
  computed: {
    loading() {
      return this.chat.loading
    },
    chat_id() {
      return this.chat.id
    },
    generating() {
      return this.chat.generating
    },
    readonly() {
      return this.chat.readonly
    },
    ref_history_len() {
      return this.chat.ref_history_len
    },
    can_share() {
      return !this.loading && !!$global.chatSharingEnabled && !!this.chat_id
    },
    shared(){
      return !!this.chat.share
    }
  },
  created() {
    this.$listen('meeting-save', idx => this.$debounce_400(this.saveMeeting, idx))
    this.$listen('document-save', ev => this.$debounce_400(this.saveDocument, ev))
    this.$listen('answer-ai', this.onAnswerAi)
  },
  methods: {
    onLike(idx, feedback) {
      return this.chat.like(idx, feedback)
    },
    onDislike(idx, feedback) {
      return this.chat.dislike(idx, feedback)
    },
    onSave(idx, text) {
      return this.chat.savePost(idx, text)
    },
    share(){
      this.$refs.share.open()
    },
    async onChat(params) {
      await this.chat.doChat(params)
    },
    async onAnswerAi(params){
      await this.chat.doChat(params, true)
    },
    onStop() {
      this.chat.stopChat()
    },
    async onRegenerateFragment(history_idx, range) {
      await this.chat.regenratePostFragment(history_idx, range.start_idx, range.end_idx)
    },
    async saveMeeting(history_idx) {
      await this.chat.doChat({
        text: 'Create a presentation....',
        command: 'generate_presentation',
        command_args: {history_idx}
      })
    },
    async savePodcast(history_idx) {
      await this.chat.doChat({
        text: 'Create a Prep Podcast episode',
        command: 'generate_audio',
        command_args: {history_idx}
      })
    },
    async onReasoning(ev) {
      this.chat.updateReasoning(ev)
    },
    async saveDocument(ev) {
      let text = 'Please create a pdf document'
      if (ev.ext === 'docx'){
        text = 'Please create a Microsoft Word document'
      }
      await this.chat.doChat({
        text: text,
        command: 'generate_document',
        command_args: ev
      })
    },
    onPromptSave(idx) {
      const data = this.chat.history[idx].data
      const title = data.title?.substr(0, 256) || ''
      this.$refs.prompts.open({title, prompt: data.text.substr(0, 2048)})
    },
  }
}
